/**!
 * Created by Leonardo Cheslacki on 19/08/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import {initializeApp} from 'firebase/app';

import {
    getAuth,
    fetchSignInMethodsForEmail,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    onAuthStateChanged,
    signOut
} from 'firebase/auth';

import {
    getDatabase,
    ref,
    onValue,
    onChildAdded,
    onChildChanged,
    query,
    orderByChild,
    limitToLast
} from 'firebase/database';

import Moment from 'moment';

import 'moment/locale/pt-br';

Moment.locale('pt-br');

import Big from 'big.js';

import HelpersController from './HelpersController';

let _this = {};

/**
 *
 */
class HelpersFireBase extends HelpersController {

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.props = props;
        _this = this;
        this.state = {
            uid: null
        };
        this.$snapshotMessages = null;
        this.$app = initializeApp(props);
        this.init();
    };

    init = () => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            user && (this.state.uid = user.uid);
        });
        this.onSnapshotMessages();
    };

    /**
     *
     * @returns {number|*}
     */
    getUid = () => {
        const auth = getAuth();
        let uid = this.getState('uid');
        !uid && (uid = this.state.uid = this.verifyField(auth, 'currentUser.uid', false, null));

        return uid;
    };

    /**
     * Errors: auth/invalid-email, auth/user-disabled, auth/user-not-found, auth/wrong-password
     */
    login = () => {
        const auth = getAuth();
        fetchSignInMethodsForEmail(auth, 'cheslacki@gmail.com').then((response) => {
            if (this.inArray(response, 'password')) {
                signInWithEmailAndPassword(auth, 'cheslacki@gmail.com', '123456789@').then((response) => {
                    console.log(this.getUid());
                }).catch((errors) => {
                    console.log(errors.code);
                });
            }
        });
    };

    /**
     * Logout
     */
    logout = () => {
        const auth = getAuth();
        signOut(auth).then((response) => {
            console.log(response);
            this.$snapshotMessages && this.$snapshotMessages.off();
            this.state.uid = null;
        }).catch((errors) => {
            console.log(errors);
        });
    };

    /**
     *
     * Errors: auth/email-already-in-use, auth/invalid-email, auth/operation-not-allowed, auth/weak-password
     * @param email
     * @param password
     */
    register = (email, password) => {
        const auth = getAuth();
        createUserWithEmailAndPassword(auth, email, password).then((response) => {
            console.log(response);
        }).catch((errors) => {
            console.log(errors.code);
        });
    };

    /**
     *
     * @param callback
     */
    onSnapshotMessages = () => {
        this.$snapshotMessages && this.$snapshotMessages.off();

        const database = getDatabase();

        this.$snapshotMessages = query(ref(database, '/messages'), orderByChild('created_at'), limitToLast(1));

        onChildAdded(this.$snapshotMessages, (snapshot) => {
            console.log(snapshot.key, snapshot.val());
        });
    }

    test = () => {
        this.login()
    };
}

/**
 *
 * @type {{alpha_max: Requireable<number>, _SOURCE_: Requireable<string>, alpha_min: Requireable<number>, _TITLE_: Requireable<string>, _LOCATION_: Requireable<string>, window: Requireable<object>}}
 */
const propTypes = {
    apiKey: PropTypes.string,
    authDomain: PropTypes.string,
    databaseURL: PropTypes.string,
    projectId: PropTypes.string,
    storageBucket: PropTypes.string,
    messagingSenderId: PropTypes.string,
    appId: PropTypes.string,
    measurementId: PropTypes.string
};

/**
 *
 * @type {{default: {alpha_max: number, _SOURCE_: string, alpha_min: number, _TITLE_: string, _LOCATION_: null, window: {}}}}
 */
const config = {
    default: {
        apiKey: 'AIzaSyCYxZ7VkO6PRyrb2SmZTjGd9LcppdVGUTo',
        authDomain: 'restfulengine-1499519296671.firebaseapp.com',
        databaseURL: 'https://restfulengine-1499519296671-default-rtdb.firebaseio.com',
        projectId: 'restfulengine-1499519296671',
        storageBucket: 'restfulengine-1499519296671.appspot.com',
        messagingSenderId: '495828660318',
        appId: '1:495828660318:web:a5360961821f0d926204cf',
        measurementId: 'G-TBQ81D37S7'
    }
};

export default (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersFireBase');
    return (new HelpersFireBase(defaultProps));
};